import { TabButtonDesktop } from "/App.Components";
import "./TabListDesktop.scss";

interface TabButtonProps {
  text?: string;
  propertyName?: string;
  selected?: boolean;
  onClick: () => void;
}

interface Props {
  tabButtons: TabButtonProps[];
}

const TabListDesktop = ({ tabButtons }: Props) => (
  <div className="tab-list-desktop-norad">
    {tabButtons.map((item, idx) => (
      <TabButtonDesktop {...item} key={idx} />
    ))}
  </div>
);

export default TabListDesktop;
